<template>
  <b-row>
    <b-col cols="12">
      <b-form-group label="ชื่อผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)">
        <b-form-input
          v-if="company.companyName != null && !isEdit"
          v-model="company.companyName"
          :value="company.companyName"
          readonly
          class="col-6"
        />
        <b-row v-else>
          <vue-autosuggest
            v-model="company.companyName"
            :suggestions="filteredOptions"
            :limit="limit"
            :input-props="inputProps"
            class="col-6"
            @selected="onSelected"
            @input="onInputChange"
          >
            <template slot-scope="{ suggestion }">
              <span class="my-suggestion-item">{{ suggestion.item.name }}</span>
            </template>
          </vue-autosuggest>
          <!-- <b-button v-if="isEdit" @click="onA" class="col-2 ml-1" variant="outline-primary">แก้ไข</b-button> -->
          <b-button
            v-if="typeof ReadOnly === 'undefined' && IsDeleteAble === true"
            class="col-2 ml-1"
            variant="danger"
            @click="onDeleteBtnClicked"
            >ลบ</b-button
          >
        </b-row>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group label="รายละเอียดเพิ่มเติมของผู้ที่ท่านร้องทุกข์">
        <!-- <span class="text-danger">**โปรดระบุข้อมูลอย่างละเอียด เพื่อความรวดเร็วในการดำเนินการของเจ้าหน้าที่</span> -->
        <b-form-textarea
          v-model="company.companyDetail"
          placeholder="รายละเอียดเพิ่มเติมของผู้ที่ท่านร้องทุกข์"
          :v-text="selected"
          :readonly="!isEdit"
          rows="3"
        />
      </b-form-group>
    </b-col>
    <b-col
      v-if="
        company.complaintCompanyAddressModel !== null &&
          company.complaintCompanyAddressModel !== undefined
      "
      cols="12"
    >
      <longdo-map
        v-if="
          company.complaintCompanyAddressModel.longitude !== null &&
            company.complaintCompanyAddressModel.latitude !== null
        "
        @load="eventMap"
        :zoom="10"
        :lastView="false"
        :location="{
          lon: company.complaintCompanyAddressModel.longitude,
          lat: company.complaintCompanyAddressModel.latitude,
        }"
        style="height: 420px;"
      >
        <!-- <longdo-map-marker             
              v-for="(item, i) in markers"             
              :key="i"             
              :location="item.location"
              :title="item.title"             
              :detail="item.detail"     
          />      -->
        <longdo-map-marker
          :location="{
            lon: company.complaintCompanyAddressModel.longitude,
            lat: company.complaintCompanyAddressModel.latitude,
          }"
          :title="
            company.complaintCompanyAddressModel.address1 +
              ' ' +
              company.complaintCompanyAddressModel.address2
          "
          :detail="
            'long:' +
              company.complaintCompanyAddressModel.longitude +
              ',lat:' +
              company.complaintCompanyAddressModel.latitude
          "
        />
      </longdo-map>
    </b-col>

    <div
      class="mb-1"
      v-if="
        company.complaintCompanyAddressModel !== null &&
          company.complaintCompanyAddressModel !== undefined
      "
    >
      <span
        v-if="
          company.complaintCompanyAddressModel.longitude === null &&
            company.complaintCompanyAddressModel.latitude === null
        "
        >*ผู้ร้องไม่ได้ระบุพิกัดบนแผนที่</span
      >
    </div>

    <b-col
      v-if="
        company.complaintCompanyAddressModel !== null &&
          company.complaintCompanyAddressModel !== undefined
      "
      cols="12"
    >
      <b-form-group label="ที่ตั้ง/ที่อยู่">
        <CompanyAddress :address="company.complaintCompanyAddressModel" />
      </b-form-group>
    </b-col>

    <b-col
      v-if="
        company.complaintCompanyContacts !== null &&
          company.complaintCompanyContacts !== undefined
      "
      cols="12"
    >
      <b-form-group label="ข้อมูลติดต่อผู้ประกอบการ">
        <b-list-group-item>
          <b-row>
            <b-form-group
              v-for="(item, key) in company.complaintCompanyContacts"
              :key="key"
              :label="item.contactType"
              class="col-6"
            >
              <b-form-input :value="item.description" readonly="readonly">
              </b-form-input>
            </b-form-group>
          </b-row>
        </b-list-group-item>
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BFormTextarea,
  BButton,
  BFormInput,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import { VueAutosuggest } from "vue-autosuggest";
import CompanyAddress from "../components/CompanyAddress.vue";
import * as companyStore from "@/store/api/company/index.js";
import { LongdoMap, LongdoMapMarker } from "longdo-map-vue";
LongdoMap.init({ apiKey: "ef7ba3e6cea0104eb5aafaf4b4733e0f" });

export default {
  components: {
    BFormInput,
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BFormTextarea,
    BListGroup,
    BListGroupItem,
    VueAutosuggest,
    CompanyAddress,
    LongdoMap,
    LongdoMapMarker,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
    edit: {
      type: Boolean,
      required: false,
      default: true,
    },
    IsReadOnly: 0,
    IsDeleteAble: false,
  },
  setup(props) {
    console.log("props companyDetail", props);
    return {
      comp: props.company,
      isEdit: props.edit,
      selected: props.company.companyDetail,
      index: props.company.id,
      ReadOnly: props.IsReadOnly,
    };
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
    };
  },
  created() {
    this.$http.get("/autosuggest/data").then((res) => {
      this.datasuggest = res;
    });
  },
  methods: {
    eventMap(map) {
      map.Ui.Crosshair.visible(false);
      map.Ui.lockMap(true);
    },
    onSelected(option) {
      this.selected = option.item.name;
      console.log(option);
      this.$emit("handle-value-selected", this.index, option.item.name);
    },
    onDeleteBtnClicked() {
      this.$emit("handle-del-btn", this.index);
    },
    onInputChange(text) {
      if (text === "" || text === undefined) {
        return;
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredCompany = this.datasuggest.data[0].company
        .filter(
          (item) => item.name.toLowerCase().indexOf(text.toLowerCase()) > -1,
        )
        .slice(0, this.limit);
      this.filteredOptions = [
        {
          data: filteredCompany,
        },
      ];
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-autosuggest.scss";
</style>
